import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cohensDPerformed: false,
    cohensdCoreDataId: null,
    cohensdBackendVariables: [],
    cohensdProductCodes: [],
};

export const cohensDSlice = createSlice({
    name: "cohensDStore",
    initialState,
    reducers: {
        loadCohensDPerformed: (state, action) => {
            state.cohensDPerformed = action.payload;
        },
       
        loadCohensdCoreDataId: (state, action) => {
            state.cohensdCoreDataId = action.payload;
        },
        loadCohensdBackendVariables: (state, action) => {
            state.cohensdBackendVariables = action.payload;
        },
        loadCohensdProductCodes: (state, action) => {
            state.cohensdProductCodes = action.payload;
        },
        resetCohensDStore: () => initialState,
    },
});

export const {
    loadCohensDPerformed,
    loadCohensdCoreDataId,
    loadCohensdBackendVariables,
    loadCohensdProductCodes,
    resetCohensDStore,
} = cohensDSlice.actions;

export default cohensDSlice.reducer;